import { createOrder } from 'actions/entities/orders/createOrder/createOrder';
import { createPayment } from 'actions/entities/payments/payments';
import {
  trackCreateCheckoutPayment,
  trackCreateCheckoutPaymentError,
} from 'actions/tracker/tracker';
import { setPayerInformationCountrySuggestion } from 'actions/ui/ui';
import type { PayexThunkAction } from 'store/configureStore';

export const createCheckoutPayment =
  (options: { skipPayment?: boolean } = {}): PayexThunkAction<Promise<void>> =>
  async dispatch => {
    const { skipPayment = false } = options;

    dispatch(setPayerInformationCountrySuggestion(''));

    try {
      await dispatch(createOrder());

      if (!skipPayment) {
        await dispatch(createPayment());
        dispatch(trackCreateCheckoutPayment());
      }
    } catch (error) {
      const normalizedError =
        error instanceof Error ? error : new Error(String(error));
      dispatch(trackCreateCheckoutPaymentError(normalizedError));
      throw normalizedError;
    }
  };
